export var NOTIFICATION_ERROR = 'There was an error with your request. Please try again later.';
export var PAGE_SIZE_THREE = 3;
export var FILTER_CREATION_FLAGS = {
  LGBTQ_PLUS: 'LGBTQ_PLUS',
  NEW_POPULATION: 'NEW_POPULATION'
};
export var SEARCH_ROLES = {
  PAYMENTS: 'payments'
};
export var SERVICE_AREA_TYPES = {
  NATIONAL: 'national',
  STATE: 'state'
};
export var STATIC_FILTER_OPTIONS = {
  TRANSPORTATION_OPTIONS: [{
    label: 'Free Transportation',
    value: 'free_transportation'
  }],
  POPULATIONS: [{
    label: 'Blind or low vision',
    value: 'blind_or_low_vision',
    flags: [FILTER_CREATION_FLAGS.NEW_POPULATION]
  }, {
    label: 'Caregivers (Non-parental)',
    value: 'caregivers',
    flags: []
  }, {
    label: 'Deaf or hard of hearing',
    value: 'deaf_or_hard_of_hearing',
    flags: [FILTER_CREATION_FLAGS.NEW_POPULATION]
  }, {
    label: 'Domestic violence survivors',
    value: 'domestic_violence_survivors',
    flags: []
  }, {
    label: 'Homebound',
    value: 'homebound',
    flags: []
  }, {
    label: 'Homeless',
    value: 'homeless',
    flags: []
  }, {
    label: 'Immigrants and refugees',
    value: 'immigrants_and_refugees',
    flags: []
  }, {
    label: 'Justice-involved',
    value: 'justice_involved',
    flags: []
  }, {
    label: 'LGBTQ+',
    value: 'lgbtq_plus',
    flags: [FILTER_CREATION_FLAGS.LGBTQ_PLUS]
  }, {
    label: 'Low-income individuals and households',
    value: 'low_income_individuals_and_households',
    flags: []
  }, {
    label: 'Native Americans or Alaska Natives',
    value: 'native_americans_or_alaska_natives',
    flags: []
  }, {
    label: 'People with cognitive disabilities',
    value: 'people_with_cognitive_disabilities',
    flags: []
  }, {
    label: 'People with chronic conditions',
    value: 'people_with_chronic_conditions',
    flags: [FILTER_CREATION_FLAGS.NEW_POPULATION]
  }, {
    label: 'People with developmental disabilities',
    value: 'people_with_developmental_disabilities',
    flags: []
  }, {
    label: 'People with HIV/AIDS',
    value: 'people_with_hiv_aids',
    flags: []
  }, {
    label: 'People with learning disabilities',
    value: 'people_with_learning_disabilities',
    flags: [FILTER_CREATION_FLAGS.NEW_POPULATION]
  }, {
    label: 'People with mental health issues',
    value: 'people_with_mental_health_issues',
    flags: []
  }, {
    label: 'People with physical disabilities',
    value: 'people_with_physical_disabilities',
    flags: []
  }, {
    label: 'People with substance use issues',
    value: 'people_with_substance_abuse_issues',
    flags: []
  }, {
    label: 'Pregnancy',
    value: 'pregnancy',
    flags: []
  }, {
    label: 'Registered sex offenders',
    value: 'registered_sex_offenders',
    flags: []
  }, {
    label: 'Sexual assault survivors',
    value: 'sexual_assault_survivors',
    flags: []
  }, {
    label: 'Veterans and military families',
    value: 'veterans_and_military_families',
    flags: []
  }, {
    label: 'Victims of natural disaster',
    value: 'victims_of_natural_disaster',
    flags: []
  }, {
    label: 'Victims of crime',
    value: 'victims_of_crime',
    flags: []
  }, {
    label: 'Unemployed',
    value: 'unemployed',
    flags: []
  }],
  ACCESSIBILITY_OPTIONS: [{
    label: 'ADA accessible',
    value: 'ada_accessible'
  }, {
    label: 'Blind accommodation',
    value: 'blind_accomodation'
  }, {
    label: 'Deaf and hard of hearing accommodation',
    value: 'deaf_or_hard_of_hearing'
  }, {
    label: 'Interpreter/translation services available',
    value: 'translation_services'
  }],
  LANGUAGE_OPTIONS: [{
    label: 'Afrikaans',
    value: 'af'
  }, {
    label: 'Albanian',
    value: 'sq'
  }, {
    label: 'American Sign Language',
    value: 'american_sign_language'
  }, {
    label: 'Amharic',
    value: 'am'
  }, {
    label: 'Arabic',
    value: 'ar'
  }, {
    label: 'Armenian',
    value: 'hy'
  }, {
    label: 'Basque',
    value: 'eu'
  }, {
    label: 'Bengali',
    value: 'bn'
  }, {
    label: 'Bosnian',
    value: 'bs'
  }, {
    label: 'Burmese',
    value: 'my'
  }, {
    label: 'Bulgarian',
    value: 'bg'
  }, {
    label: 'Catalan',
    value: 'ca'
  }, {
    label: 'Central Khmer',
    value: 'km'
  }, {
    label: 'Chinese',
    value: 'zh'
  }, {
    label: 'Chuukese',
    value: 'chk'
  }, {
    label: 'Croatian',
    value: 'hr'
  }, {
    label: 'Czech',
    value: 'cs'
  }, {
    label: 'Danish',
    value: 'da'
  }, {
    label: 'Dari',
    value: 'prs'
  }, {
    label: 'Dutch',
    value: 'nl'
  }, {
    label: 'English',
    value: 'en'
  }, {
    label: 'Estonian',
    value: 'et'
  }, {
    label: 'Farsi',
    value: 'fa'
  }, {
    label: 'Fijian',
    value: 'fj'
  }, {
    label: 'Finnish',
    value: 'fi'
  }, {
    label: 'French',
    value: 'fr'
  }, {
    label: 'Georgian',
    value: 'ka'
  }, {
    label: 'German',
    value: 'de'
  }, {
    label: 'Gujarati',
    value: 'gu'
  }, {
    label: 'Haitian Creole',
    value: 'ht'
  }, {
    label: 'Hawaiian',
    value: 'haw'
  }, {
    label: 'Hebrew',
    value: 'he'
  }, {
    label: 'Hindi',
    value: 'hi'
  }, {
    label: 'Hmong',
    value: 'hmn'
  }, {
    label: 'Hungarian',
    value: 'hu'
  }, {
    label: 'Icelandic',
    value: 'is'
  }, {
    label: 'Ilocano',
    value: 'ilo'
  }, {
    label: 'Indonesian',
    value: 'id'
  }, {
    label: 'Irish',
    value: 'ga'
  }, {
    label: 'Italian',
    value: 'it'
  }, {
    label: 'Japanese',
    value: 'ja'
  }, {
    label: 'Kinyarwanda',
    value: 'rw'
  }, {
    label: 'Kirundi',
    value: 'rn'
  }, {
    label: 'Korean',
    value: 'ko'
  }, {
    label: 'Kosraean',
    value: 'kos'
  }, {
    label: 'Lao',
    value: 'lo'
  }, {
    label: 'Latin',
    value: 'la'
  }, {
    label: 'Latvian',
    value: 'lv'
  }, {
    label: 'Lithuanian',
    value: 'lt'
  }, {
    label: 'Maay Maay',
    value: 'ymm'
  }, {
    label: 'Macedonian',
    value: 'mk'
  }, {
    label: 'Malay',
    value: 'ms'
  }, {
    label: 'Malayalam',
    value: 'ml'
  }, {
    label: 'Maltese',
    value: 'mt'
  }, {
    label: 'Maori',
    value: 'mi'
  }, {
    label: 'Marathi',
    value: 'mr'
  }, {
    label: 'Marshallese',
    value: 'mh'
  }, {
    label: 'Modern Greek (1453-)',
    value: 'el'
  }, {
    label: 'Mongolian',
    value: 'mn'
  }, {
    label: 'Nepali',
    value: 'ne'
  }, {
    label: 'Norwegian',
    value: 'no'
  }, {
    label: 'Oromo',
    value: 'om'
  }, {
    label: 'Punjabi',
    value: 'pa'
  }, {
    label: 'Persian',
    value: 'pe'
  }, {
    label: 'Pohnpeian',
    value: 'pon'
  }, {
    label: 'Polish',
    value: 'pl'
  }, {
    label: 'Portuguese',
    value: 'pt'
  }, {
    label: 'Quechua',
    value: 'qu'
  }, {
    label: 'Romanian',
    value: 'ro'
  }, {
    label: 'Russian',
    value: 'ru'
  }, {
    label: 'Samoan',
    value: 'sm'
  }, {
    label: 'Serbian',
    value: 'sr'
  }, {
    label: 'Slovak',
    value: 'sk'
  }, {
    label: 'Slovenian',
    value: 'sl'
  }, {
    label: 'Somali',
    value: 'so'
  }, {
    label: 'Spanish',
    value: 'es'
  }, {
    label: 'Swahili',
    value: 'sw'
  }, {
    label: 'Swedish',
    value: 'sv'
  }, {
    label: 'Tagalog',
    value: 'tl'
  }, {
    label: 'Tamil',
    value: 'ta'
  }, {
    label: 'Tatar',
    value: 'tt'
  }, {
    label: 'Telugu',
    value: 'te'
  }, {
    label: 'Thai',
    value: 'th'
  }, {
    label: 'Tibetan',
    value: 'bo'
  }, {
    label: 'Tonga (Tonga Islands)',
    value: 'to'
  }, {
    label: 'Turkish',
    value: 'tr'
  }, {
    label: 'Ukrainian',
    value: 'uk'
  }, {
    label: 'Urdu',
    value: 'ur'
  }, {
    label: 'Uzbek',
    value: 'uz'
  }, {
    label: 'Vietnamese',
    value: 'vi'
  }, {
    label: 'Welsh',
    value: 'cy'
  }, {
    label: 'Xhosa',
    value: 'xh'
  }, {
    label: 'Yapese',
    value: 'yap'
  }],
  PAYMENT_OPTIONS: [{
    label: 'Free',
    value: 'free'
  }, {
    label: 'Insurance',
    value: 'insurance'
  }, {
    label: 'Self-pay',
    value: 'self_pay'
  }, {
    label: 'Sliding Scale',
    value: 'sliding_scale'
  }],
  PROGRAM_DELIVERY_OPTIONS: [{
    label: 'In Home',
    value: 'in_home'
  }, {
    label: 'In Office',
    value: 'in_office'
  }, {
    label: 'Web Based',
    value: 'web_based'
  }, {
    label: 'Phone Based',
    value: 'phone_based'
  }],
  GENDER_OPTIONS: [{
    label: 'Male',
    value: 'male',
    flags: []
  }, {
    label: 'Female',
    value: 'female',
    flags: []
  }, {
    label: 'Trans Woman',
    value: 'trans-woman',
    flags: [FILTER_CREATION_FLAGS.LGBTQ_PLUS]
  }, {
    label: 'Trans Man',
    value: 'trans-man',
    flags: [FILTER_CREATION_FLAGS.LGBTQ_PLUS]
  }, {
    label: 'Non-Binary',
    value: 'non-binary',
    flags: [FILTER_CREATION_FLAGS.LGBTQ_PLUS]
  }, {
    label: 'Other',
    value: 'other',
    flags: [FILTER_CREATION_FLAGS.LGBTQ_PLUS]
  }, {
    label: 'Undisclosed',
    value: 'undisclosed',
    flags: []
  }],
  US_STATES: [{
    display_name: 'Alaska',
    value: 'AK'
  }, {
    display_name: 'Alabama',
    value: 'AL'
  }, {
    display_name: 'Arkansas',
    value: 'AR'
  }, {
    display_name: 'American Samoa',
    value: 'AS'
  }, {
    display_name: 'Arizona',
    value: 'AZ'
  }, {
    display_name: 'California',
    value: 'CA'
  }, {
    display_name: 'Colorado',
    value: 'CO'
  }, {
    display_name: 'Connecticut',
    value: 'CT'
  }, {
    display_name: 'District of Columbia',
    value: 'DC'
  }, {
    display_name: 'Delaware',
    value: 'DE'
  }, {
    display_name: 'Florida',
    value: 'FL'
  }, {
    display_name: 'Georgia',
    value: 'GA'
  }, {
    display_name: 'Guam',
    value: 'GU'
  }, {
    display_name: 'Hawaii',
    value: 'HI'
  }, {
    display_name: 'Iowa',
    value: 'IA'
  }, {
    display_name: 'Idaho',
    value: 'ID'
  }, {
    display_name: 'Illinois',
    value: 'IL'
  }, {
    display_name: 'Indiana',
    value: 'IN'
  }, {
    display_name: 'Kansas',
    value: 'KS'
  }, {
    display_name: 'Kentucky',
    value: 'KY'
  }, {
    display_name: 'Louisiana',
    value: 'LA'
  }, {
    display_name: 'Massachusetts',
    value: 'MA'
  }, {
    display_name: 'Maryland',
    value: 'MD'
  }, {
    display_name: 'Maine',
    value: 'ME'
  }, {
    display_name: 'Michigan',
    value: 'MI'
  }, {
    display_name: 'Minnesota',
    value: 'MN'
  }, {
    display_name: 'Missouri',
    value: 'MO'
  }, {
    display_name: 'Northern Mariana Islands',
    value: 'MP'
  }, {
    display_name: 'Mississippi',
    value: 'MS'
  }, {
    display_name: 'Montana',
    value: 'MT'
  }, {
    display_name: 'North Carolina',
    value: 'NC'
  }, {
    display_name: 'North Dakota',
    value: 'ND'
  }, {
    display_name: 'Nebraska',
    value: 'NE'
  }, {
    display_name: 'New Hampshire',
    value: 'NH'
  }, {
    display_name: 'New Jersey',
    value: 'NJ'
  }, {
    display_name: 'New Mexico',
    value: 'NM'
  }, {
    display_name: 'Nevada',
    value: 'NV'
  }, {
    display_name: 'New York',
    value: 'NY'
  }, {
    display_name: 'Ohio',
    value: 'OH'
  }, {
    display_name: 'Oklahoma',
    value: 'OK'
  }, {
    display_name: 'Oregon',
    value: 'OR'
  }, {
    display_name: 'Pennsylvania',
    value: 'PA'
  }, {
    display_name: 'Puerto Rico',
    value: 'PR'
  }, {
    display_name: 'Rhode Island',
    value: 'RI'
  }, {
    display_name: 'South Carolina',
    value: 'SC'
  }, {
    display_name: 'South Dakota',
    value: 'SD'
  }, {
    display_name: 'Tennessee',
    value: 'TN'
  }, {
    display_name: 'Texas',
    value: 'TX'
  }, {
    display_name: 'United States Minor Outlying Islands',
    value: 'UM'
  }, {
    display_name: 'Utah',
    value: 'UT'
  }, {
    display_name: 'Virginia',
    value: 'VA'
  }, {
    display_name: 'Virgin Islands',
    value: 'VI'
  }, {
    display_name: 'Vermont',
    value: 'VT'
  }, {
    display_name: 'Washington',
    value: 'WA'
  }, {
    display_name: 'Wisconsin',
    value: 'WI'
  }, {
    display_name: 'West Virginia',
    value: 'WV'
  }, {
    display_name: 'Wyoming',
    value: 'WY'
  }, {
    display_name: 'Armed Forces Americas (except Canada)',
    value: 'AA'
  }, {
    display_name: 'Armed Forces Africa, Canada, Europe, Middle East',
    value: 'AE'
  }, {
    display_name: 'Armed Forces Pacific',
    value: 'AP'
  }],
  AGE_UNITS: [{
    label: 'Years',
    value: 'years'
  }, {
    label: 'Months',
    value: 'months'
  }],
  PROGRAM_STATUS: [{
    label: 'Receiving On-Platform Referrals',
    value: 'on-platform',
    initial: true
  }, {
    label: 'Receiving Off-Platform Referrals',
    value: 'off-platform',
    initial: true
  }, {
    label: 'All Programs',
    value: 'allPrograms',
    initial: false
  }],
  FAVORITE_STATUS: [{
    label: 'My Favorited Programs',
    value: 'true'
  }, {
    label: 'Non-Favorited Programs',
    value: 'false'
  }],
  SORT: [{
    label: 'Sort: Relevance',
    value: 'relevance'
  }, {
    label: 'Sort: Distance',
    value: 'distance'
  }, {
    label: 'Sort: A to Z',
    value: 'program-name-a-to-z'
  }]
};
//# sourceMappingURL=constants.js.map